import React from 'react';
import { Block, CheckingBoxIcon, DefaultText, FlexRow } from '@guryou/html-components';

const CheckboxInfoContainer = ({ text }) => {
  return (
    <FlexRow margin={0} padding={0} marginTop={5} xs={12}>
      <Block lg={0.6} md={1} xs={1.5} padding={0.2} margin={0}>
        <CheckingBoxIcon htmlColor="green" />
      </Block>
      <DefaultText lg={10.5} md={10} xs={10}>
        {text}
      </DefaultText>
    </FlexRow>
  );
};

export default CheckboxInfoContainer;
